<div class="grid-mobile-1 grid-tablet-1 grid-desktop-2 full-height">
  <app-card header="Klantgegevens">
    <app-badge size="small" ngProjectAs="[badge]" icon="address-card"></app-badge>
    <ul>
      <li><span>Klantnaam:</span><span>{{ this.activeRelation?.full_name }}</span></li>
      <li><span>Klanttype:</span><span>{{ this.activeRelation?.is_business ? 'Zakelijk' : 'Particulier' }}</span></li>
      @if (this.activeRelation?.is_business) {
        <li>
          <span>KvK-nummer:</span><span>{{ this.activeRelation.coc_number || '' }}</span>
        </li>
      }
      <li><span>Klantnummer:</span><span>{{ this.activeRelation?.customer_id || '' }}</span></li>
      <li><span>Adres:</span><span>{{ this.activeRelation | address }}</span></li>
      <li><span>Postadres:</span><span>{{ this.activeRelation | postalAddress }}</span></li>
    </ul>
  </app-card>
  <app-card header="Financiële gegevens">
    <app-badge size="small" ngProjectAs="[badge]" icon="euro-sign"></app-badge>
    <ul>
      <li>
        <span>Betaalmethode:</span><span>{{ InvoiceTypeTranslations[this.activeRelation?.invoice_type ?? RelationInvoiceType.INVOICE] }}</span>
      </li>
      <li>
        <span>IBAN:</span><span>{{ this.activeRelation?.bank_account }}</span>
      </li>
      @if (this.activeRelation?.bic_number && this.activeRelation.bic_number.trim() !=='') {
        <li>
          <span>BIC:</span><span>{{ this.activeRelation.bic_number }}</span>
        </li>
      }
      @if (this.activeRelation?.is_business) {
        <li>
          <span>Btw-nummer:</span><span>{{ this.activeRelation.vat_number }}</span>
        </li>
      }
      @if (this.activeRelation?.is_business) {
        <li>
          <span>Btw-verlegd:</span><span>{{ this.activeRelation.vat_reverse_charge ? 'Actief' : 'Niet actief' }} </span>
        </li>
      }
      <li>
        <span>Digitaal factureren:</span><span>{{ this.activeRelation?.digital_fact ? 'Actief' : 'Niet actief' }} </span>
      </li>
      <li>
        <span>Facturatieperiode:</span><span>{{ InvoicePeriodTranslations[this.activeRelation?.invoice_period ?? RelationInvoicePeriod.MONTHLY] }}</span>
      </li>
      <li>
        <span>Verzamelfactuur:</span><span>{{ this.activeRelation?.fact_collective_invoice ? 'Actief' : 'Niet actief' }}</span>
      </li>
    </ul>
  </app-card>
  <app-card header="Inloggegevens">
    <app-badge size="small" ngProjectAs="[badge]" icon="circle-user"></app-badge>
    <ul>
      <li>
        <span>E-mailadres:</span><span>{{ this.user?.email }}</span>
        <app-button (click)="this.editEmail()" type="icon-only" actionType="edit" icon="pen" onKeyUp="" ariaLabel="Wijzig e-mailadres"></app-button>
      </li>
      <li>
        <span>Wachtwoord:</span><span>********</span>
        <app-button (click)="this.editPassword()" type="icon-only" actionType="edit" icon="pen" onKeyUp="" ariaLabel="Wijzig wachtwoord"></app-button>
      </li>
    </ul>
  </app-card>
  @if (!this.activeRelation?.is_business) {
    <app-card header="Communicatie voorkeuren">
      <app-badge size="small" ngProjectAs="[badge]" icon="lightbulb-message"></app-badge>
      <span class="description">
        Kies zelf welke berichten je van {{config.companyName}} ontvangt. Zo blijf je op de hoogte!
      </span>
      <ul>
        <li>
          <span><b>Aanbiedingen</b></span>
        </li>
        <li class="preference-item">
          <span>
            Ja, ik ontvang graag aanbiedingen, voordeelacties en andere interessante extra's van {{config.companyName}}.
          </span>
          <div class="toggles">
            <app-toggle
              name="email"
              label="Per e-mail"
              [checked]="activeRelation?.communication_preferences?.email ?? false"
              (toggled)="onToggleChange($event)">
            </app-toggle>
            <app-toggle
              name="phone"
              label="Per telefoon"
              [checked]="activeRelation?.communication_preferences?.phone ?? false"
              (toggled)="onToggleChange($event)">
            </app-toggle>
          </div>
        </li>
      </ul>
      <span>
        Je past jouw communicatievoorkeuren op ieder moment eenvoudig aan in {{config.appName}}.
      </span>
      <span>
        Meer weten over hoe wij omgaan met jouw gegevens? Bekijk ons privacy statement.
      </span>
    </app-card>
  }
  <app-card header="Contactpersonen">
    <app-badge size="small" ngProjectAs="[badge]" icon="users"></app-badge>
    <ul>
      @for (relationContact of relationContacts; track relationContact; let first = $first) {
        @if (!first) {
          <app-divider></app-divider>
        }
        <li>
          <span><b>{{ relationContact.name }}</b>
          @if (relationContact.email === this.user?.email) {
            <app-icon icon="user" title="Dit ben ik!"/>
          }
        </span>
      </li>
      <li>
        <span>E-mailadres:</span>
        <span>{{ relationContact.email }}</span>
      </li>
      @if (relationContact.phone1 && relationContact.phone2) {
        <li>
          <span>Telefoonnummer 1:</span>
          <span>{{ relationContact.phone1 | phone }}</span>
        </li>
        <li>
          <span>Telefoonnummer 2:</span>
          <span>{{ relationContact.phone2 | phone }}</span>
        </li>
      } @else {
        @if (relationContact.phone1 || relationContact.phone2) {
          <li>
            <span>Telefoonnummer:</span>
            <span>{{ relationContact.phone1 || relationContact.phone2 | phone }}</span>
          </li>
        }
      }
    }
  </ul>
</app-card>
</div>
